// extracted by mini-css-extract-plugin
export default {"btn":"PlayerInsightButton_btn__D+zfR"};